export const ActionTypes = {
  GET_PANEL_LIST: "GET_PANEL_LIST",
  GET_PANEL_LIST_BY_ID: "GET_PANEL_LIST_BY_ID",
  PANEL_TOGGLE: "PANEL_TOGGLE",
  PANEL_DISABLE: "PANEL_DISABLE",
  WIDGET_ENABLE: "WIDGET_ENABLE",
  GET_DEFAULT_SETTINGS: "GET_DEFAULT_SETTINGS",
  ADD_PANEL: "ADD_PANEL",
  UPDATE_PANEL: "UPDATE_PANEL",
  REMOVE_PANEL: "REMOVE_PANEL",
  RESET_STATE: 'RESET_STATE'
};
